<template>
  <AnalyticsWidget
    title="Glass Size Projections"
    subTitle="Projections about each glass size for the stock item based on last 12 months"
    :gridWidth="gridWidth"
    :gridHeight="gridHeight">

    <LoadingPanel :loading="loading" />
    <AnalyticsBreakdownTable v-if="!loading">
      <template v-slot:header>
        <tr>
          <th>Size</th>
          <th>Total Full Sheets</th>
          <th>Total Offcuts</th>
          <th>Total Area</th>
          <th><Tooltip label="Based on usage over the last 12 months" helpStyle>Daily Usage</Tooltip></th>
          <th><Tooltip label="Based on upcoming purchase orders" helpStyle>Incoming Stock</Tooltip></th>
          <th>Maintain Level</th>
          <th><Tooltip label="Projected date to pass the maintain level based on usage trends" helpStyle>Pass Maintain Level</Tooltip></th>
          <th>Reorder Level</th>
          <th><Tooltip label="Projected date to pass the reorder level based on usage trends" helpStyle>Pass Reorder Level</Tooltip></th>
        </tr>
      </template>
      <template v-slot:body>
        <tr v-for="glassSizeSummary of glassSizeSummaryList" :key="glassSizeSummary.id">
          <td>{{glassSizeSummary.height}} x {{glassSizeSummary.width}}</td>
          <td>{{glassSizeSummary.totalFullSheets}}</td>
          <td>{{glassSizeSummary.totalOffcuts}}</td>
          <td>{{formatDecimal(glassSizeSummary.totalArea, 2, true)}} m&sup2;</td>
          <td>{{formatDecimal(glassSizeSummary.dailyUsage, 2)}}</td>
          <td>{{glassSizeSummary.incomingStock}}</td>
          <td>{{glassSizeSummary.maintainLevel}}</td>
          <td>{{formatHyphenEmptyValue(formatDate(glassSizeSummary.maintainCrossingDate))}}</td>
          <td>{{glassSizeSummary.reorderLevel}}</td>
          <td>{{formatHyphenEmptyValue(formatDate(glassSizeSummary.reorderCrossingDate))}}</td>
        </tr>
        <tr class="font-weight-bold highlight">
          <td>Totals</td>
          <td>{{totalFullSheets}}</td>
          <td>{{totalOffcuts}}</td>
          <td>{{formatDecimal(totalArea, 2, true)}} m&sup2;</td>
          <td>{{formatDecimal(totalDailyUsage, 2)}}</td>
          <td>{{totalIncomingStock}}</td>
          <td> </td>
          <td> </td>
          <td> </td>
          <td> </td>
        </tr>

      </template>
    </AnalyticsBreakdownTable>
  </AnalyticsWidget>
</template>


<script>
import moment from 'moment'

import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsBreakdownTable from '@/modules/intelligence/components/analyticsBreakdownTable'
import AnalyticsBreakdownValueCell from '@/modules/intelligence/components/analyticsBreakdownValueCell'

export default {
  name: 'InventoryGlassSizeProjectionWidget',
  components: {
    AnalyticsWidget,
    AnalyticsBreakdownTable,
    AnalyticsBreakdownValueCell
  },
  props: {
    filter: Object,
    stockId: Number,
    gridWidth: Number,
    gridHeight: Number
  },
  computed: {
    totalFullSheets() {
      return this.glassSizeSummaryList.reduce((sum, item) => sum + item.totalFullSheets, 0)
    },
    totalOffcuts() {
      return this.glassSizeSummaryList.reduce((sum, item) => sum + item.totalOffcuts, 0)
    },
    totalArea() {
      return this.glassSizeSummaryList.reduce((sum, item) => sum + item.totalArea, 0)
    },
    totalDailyUsage() {
      return this.glassSizeSummaryList.reduce((sum, item) => sum + item.dailyUsage, 0)
    },
    totalIncomingStock() {
      return this.glassSizeSummaryList.reduce((sum, item) => sum + item.incomingStock, 0)
    }
  },
  data() {
    return {
      loading: true,
      glassSizeSummaryList: []
    }
  },
  watch: {
    stockId: function() {
      this.requestData()
    }
  },
  mounted() {
    this.requestData()
  },
  methods: {
    requestData() {
      var params = {
        usageStartDate: moment().local().subtract(12, 'months').startOf('day').toDate().toISOString(),
        usageEndDate: moment().local().endOf('day').toDate().toISOString(),
        stockId: this.stockId
      }

      this.$apiService.analyticsService.getGlassSizeSummary(params)
      .then(response => {
        this.glassSizeSummaryList = response.data
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>